// extracted by mini-css-extract-plugin
export default {"list-item":"kXlgPhzFobRVtsPPA272Cw==","image":"AUubiKNa9cBbi1vyLMf6WA==","included":"iOueuhQfuQ4M-qnEIonWfg==","excluded":"sb4LHG9HSPohPtSh1NoQLg=="};